module.exports = __webpack_public_path__ + "static/media/google-plus-symbol.5a51b1b5.svg";